<template>
    <path d="M35.456 17.743l-4.486-4.26c-.517-.487-1.276-.617-1.927-.336-.645.276-1.043.874-1.043 1.56V18h-4V8.248c0-.794-.32-1.562-.882-2.124L17.876.88C17.313.32 16.55 0 15.758 0H2.999C1.344.006 0 1.35 0 3.006V29C0 30.656 1.344 32 3 32h18c1.656 0 3-1.344 3-3v-7h-2v7c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V3.007C2 2.456 2.45 2 3 2h11.002v6.504c0 .832.668 1.496 1.5 1.496H22v8H10.5c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5H28v3.292c0 .686.398 1.284 1.043 1.56.933.404 1.68-.1 1.93-.336l4.482-4.258c.351-.333.545-.78.545-1.257 0-.478-.194-.926-.544-1.258zM16.002 8.004V2.037c.175.044.33.131.462.262l5.243 5.243c.13.131.218.287.262.462h-5.967zM29.999 22.68v-7.36L33.874 19 30 22.68z"/>
</template>

<script>
export default {
    name: 'exportCsvIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 36 32');
    }
};
</script>
